import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useContext } from "react";
import Landingpage from "./pages/landingpage";
import { AppContextProvider } from "./context/AppContext";
import { AppProviderisChecked } from "./context/AppContextisChecked";
import { AuthContextProvider } from "./context/AuthContext";
import "./App.css";

function App() {
  return (
    <AuthContextProvider>
      <AppProviderisChecked>
        <AppContextProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Landingpage />} />
            </Routes>
          </Router>
        </AppContextProvider>
      </AppProviderisChecked>
    </AuthContextProvider>
  );
}

export default App;
